import { getDescriptionDeleteAccountSuccessorModal } from '../../../utils/helpers';

export const getAssignedAsAdminSuccessMessage = (
  message,
  userFullName,
  companyName
) => {
  return getDescriptionDeleteAccountSuccessorModal(
    message.replace('%%TARGET_USER%%', userFullName),
    companyName
  );
};

export const getMessageUserSuccessfullyRemoved = (
  message,
  userFullName,
  companyName
) => {
  return getDescriptionDeleteAccountSuccessorModal(
    message.replace('%%TARGET_USER%%', userFullName),
    companyName
  );
};

export const getMessageUserSuccessfullyRemovedAsCompanyAdmin = (
  message,
  userFullName,
  companyName
) => {
  return getDescriptionDeleteAccountSuccessorModal(
    message.replace('%%TARGET_USER%%', userFullName),
    companyName
  );
};

export const getTitleRemoveUserProfileModal = (message, userFullName) => {
  return message.replace('%%TARGET_USER%%', userFullName);
};

export const getFullCompanyAddress = (street, zipCode, city) => {
  return [street, zipCode, city].join(', ');
};
